import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

import Button from 'shopper/components/Button';
import Icon from 'shopper/components/Icon';

import useWishlist from 'hooks/useWishlist';

import { stripDuplicates } from 'lib/array';

const toKeywordsWithLimit = (keywords, maxKeywords) =>
  maxKeywords && keywords.length > maxKeywords
    ? keywords.slice(0, maxKeywords)
    : keywords;

const WishlistSuggestionsKeywords = ({
  className,
  gaEventCategory,
  keywordButtonType = null,
  keywordButtonTypeCanChange = false,
  keywordsDisplay = [],
  maxKeywords = null,
  ...rest
}) => {
  const { addOfferWishlistKeyword, removeOfferWishlistKeyword, offerWishlist } =
    useWishlist(gaEventCategory, {
      gaEventLabel: 'wishlist_suggestions',
    });

  const isKeywordAdded = (keywordDisplay) =>
    offerWishlist?.items.some((item) => item.keywordDisplay === keywordDisplay);

  const onKeywordButtonClick = (keywordDisplay) => {
    if (isKeywordAdded(keywordDisplay)) {
      removeOfferWishlistKeyword({ keywordDisplay });
      return;
    }

    addOfferWishlistKeyword({ keywordDisplay });
  };

  return (
    <div
      className={twMerge('flex max-w-full flex-wrap gap-2', className)}
      {...rest}
    >
      {toKeywordsWithLimit(stripDuplicates(keywordsDisplay), maxKeywords).map(
        (keywordDisplay) => {
          const keywordAlreadyAdded = isKeywordAdded(keywordDisplay);

          return (
            <Button
              key={keywordDisplay}
              iconLeft={
                <Icon name={keywordAlreadyAdded ? 'heart-filled' : 'heart'} />
              }
              size="size3"
              type={
                keywordButtonType ||
                (keywordButtonTypeCanChange && keywordAlreadyAdded
                  ? 'secondary'
                  : 'secondary-stroke')
              }
              onClick={() => onKeywordButtonClick(keywordDisplay)}
            >
              {keywordDisplay}
            </Button>
          );
        }
      )}
    </div>
  );
};

WishlistSuggestionsKeywords.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  gaEventCategory: PropTypes.string.isRequired,
  keywordButtonType: PropTypes.string,
  keywordButtonTypeCanChange: PropTypes.bool,
  keywordsDisplay: PropTypes.arrayOf(PropTypes.string),
  maxKeywords: PropTypes.number,
};

export default WishlistSuggestionsKeywords;
